// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { createSelector } from 'reselect'

import { fullFileStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/plottr').FeatureFlags} FeatureFlags
 */

/**
 * @type {function(PlottrState): FeatureFlags}
 */
export const featureFlags = createSelector(fullFileStateSelector, (state) => state.featureFlags)
